import React, { useMemo } from 'react';

import LinkParser from 'helpers/link-parser.js';
import ReadMore from 'components/ReadMore';
import { DateHelpers } from 'helpers/date-helpers';

const TypeNewsItem = props => {
  const {
    post: {
      Date,
      NewsFeedDateAdd,
      Content,
      CurrentImageIndex,
      Images,
      Title,
      Url,
    },
  } = props;
  const image = Images[parseInt(CurrentImageIndex)];

  const date = useMemo(() => {
    const [year] = DateHelpers.getDateArray(Date);
    const currentYear = DateHelpers.getCurrentYear();

    return currentYear > Number(year)
      ? DateHelpers.getMonthNameDayYearFormat(Date)
      : NewsFeedDateAdd;
  }, [Date, NewsFeedDateAdd]);

  return (
    <div className="feed-post-content__inner feed-post-content__inner--typed">
      <div className="feed-post-content__top">
        <span className="feed-post-content__hero">GoBuyside</span>
      </div>

      <div className="feed-post-content__date">{date}</div>

      <div className="feed-post-content__content-middle">
        <div className="feed-post-content__article">
          <h4 className="feed-post-content__article-title">
            <a href={Url} target="_blank" rel="noopener noreferrer">
              {Title}
            </a>
          </h4>
          <span className="feed-post-content__link">
            {LinkParser.getFirmLinkOrigin(Url)}
          </span>

          {image && (
            <figure className="feed-post-content__featured-image">
              <img
                className="feed-post-content__featured-image-img"
                src={image}
                alt={Title}
              />
            </figure>
          )}

          <div className="feed-post-content__truncated-text">
            <ReadMore text={Content} readMoreCharacterLimit={300} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypeNewsItem;
